import { FILTER_CONFIG_NAMES } from './DataConstants';
import { nullSafeGetOrElse } from './DataAccessUtils';
import ProblemTypeTreeSelect from '../components/problem_type_tree_select';

const queryString = require('qs');

/** Mirrors `fetchDataCall` query-param serialization in `thunks_wrapper.tsx`. */
export const syncLocationsOverviewQueryParams = (
	history,
	locationsStateSlice,
	filters,
	targetCollectionName
) => {
	const pagination = nullSafeGetOrElse(`${targetCollectionName}.pagination`, locationsStateSlice, {
		current: 1,
		pageSize: 10,
	});
	const sorting = nullSafeGetOrElse(`${targetCollectionName}.sorting`, locationsStateSlice, {});
	const queryParams = queryString.stringify({
		current: 1,
		pageSize: pagination.pageSize,
		...sorting,
		...filters,
	});
	history.replace(`${window.location.pathname}?${queryParams}`);
};

export const getLocationFilterConfig = ({
	filters,
	additionalFieldsFilter = null,
	showCustomers = false,
}: {
	filters: any;
	additionalFieldsFilter?: any;
	showCustomers?: boolean;
}) => {
	const regionFilter = filters[FILTER_CONFIG_NAMES.REGION];
	return [
		...(showCustomers ? [filters[FILTER_CONFIG_NAMES.CUSTOMERS]] : []),
		regionFilter && { ...regionFilter, component: ProblemTypeTreeSelect },
		filters[FILTER_CONFIG_NAMES.LOCAATION_TYPE],
		filters[FILTER_CONFIG_NAMES.BRAND],
		...(additionalFieldsFilter ? [additionalFieldsFilter] : []),
		filters[FILTER_CONFIG_NAMES.IS_ACTIVE] && {
			...filters[FILTER_CONFIG_NAMES.IS_ACTIVE],
			showOutsideDropdown: true,
			info: undefined,
		},
	].filter(Boolean);
};
